// src/components/WorkoutDetails/ExerciseList.js
import React from "react";
import ExerciseCard from "./ExerciseCard";

const ExerciseList = ({ exercises, exerciseStates, setExerciseStates, openIndex, toggleInstructions, showGifs, toggleGif }) => {
  return (
    <div>
      {exercises.map((exercise, index) => {
        const state = exerciseStates[exercise.exercise_id];
        if (!state) return null;
        return (
          <ExerciseCard
            key={`${index}-${exercise.exercise_id}`}
            exercise={exercise}
            index={index}
            state={state}
            setExerciseStates={setExerciseStates}
            toggleInstructions={toggleInstructions}
            isOpen={openIndex === index}
            showGif={showGifs[index]}
            toggleGif={toggleGif}
          />
        );
      })}
    </div>
  );
};

export default ExerciseList;
